export class RegexRules {
  static PASSWORD = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  static EMAIL = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  static INITIALS = /^[A-Za-z]{2,3}$/;
  static NUMBER = /^(?!-1$).+$/;
}